"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGuidesMachine = void 0;
const xstate_1 = require("xstate");
const axios_1 = __importDefault(require("axios"));
const assertEventType_1 = require("../../../../common/util/assertEventType");
const typings_1 = require("./typings");
const urls_1 = require("../../../api/urls");
const headers_1 = require("../../../api/headers");
const NOOP = () => {
    // no operation
};
const createGuidesMachine = (initialContext) => (0, xstate_1.createMachine)({
    id: 'guides',
    initial: typings_1.GuidesStates.INIT,
    context: Object.assign({ practiceGuides: {} }, initialContext),
    states: {
        [typings_1.GuidesStates.INIT]: {
            always: [
                {
                    target: typings_1.GuidesStates.NO_PRACTICE_GROUPS,
                    cond: 'noPracticeGroups'
                },
                { target: typings_1.GuidesStates.NO_GUIDES, cond: 'noGuidesToFetch' },
                { target: typings_1.GuidesStates.IDLE }
            ]
        },
        [typings_1.GuidesStates.NO_PRACTICE_GROUPS]: {
            type: 'final'
        },
        [typings_1.GuidesStates.NO_GUIDES]: {
            type: 'final'
        },
        [typings_1.GuidesStates.IDLE]: {
            id: typings_1.GuidesStates.IDLE,
            on: {
                [typings_1.GuidesEventType.FETCH_GUIDE]: [
                    {
                        target: typings_1.GuidesStates.SHOW_GUIDE,
                        cond: 'guideAlreadyFetched',
                        actions: ['setActivePracticeGuide']
                    },
                    {
                        target: typings_1.GuidesStates.LOADING_GUIDE,
                        actions: ['setActivePracticeGuide']
                    }
                ]
            }
        },
        [typings_1.GuidesStates.LOADING_GUIDE]: {
            invoke: {
                id: 'fetchGuide',
                src: 'fetchGuide',
                onDone: {
                    target: typings_1.GuidesStates.LOAD_GUIDE_SUCCESS,
                    actions: ['setPracticeGuides', 'onFetchSuccess']
                },
                onError: {
                    target: typings_1.GuidesStates.LOAD_GUIDE_FAILURE,
                    actions: ['onFetchError']
                }
            }
        },
        [typings_1.GuidesStates.LOAD_GUIDE_SUCCESS]: {
            always: { target: typings_1.GuidesStates.SHOW_GUIDE }
        },
        [typings_1.GuidesStates.LOAD_GUIDE_FAILURE]: {
            on: {
                [typings_1.GuidesEventType.FETCH_GUIDE]: [
                    {
                        target: typings_1.GuidesStates.SHOW_GUIDE,
                        cond: 'guideAlreadyFetched',
                        actions: ['setActivePracticeGuide']
                    },
                    {
                        target: typings_1.GuidesStates.LOADING_GUIDE,
                        actions: ['setActivePracticeGuide']
                    }
                ]
            }
        },
        [typings_1.GuidesStates.SHOW_GUIDE]: {
            on: {
                [typings_1.GuidesEventType.HIDE_GUIDE]: {
                    target: typings_1.GuidesStates.IDLE
                }
            }
        }
    }
}, {
    guards: {
        guideAlreadyFetched: (context, event) => {
            (0, assertEventType_1.assertEventType)(event, typings_1.GuidesEventType.FETCH_GUIDE);
            return context.practiceGuides[event.payload.id] != null;
        },
        noPracticeGroups: (context) => {
            var _a;
            return (((_a = context.provider.practice_groups) === null || _a === void 0 ? void 0 : _a.length) || 0) <= 0;
        },
        noGuidesToFetch: (context) => {
            var _a, _b;
            return ((_b = !((_a = context.provider.practice_groups) === null || _a === void 0 ? void 0 : _a.some((practice) => !!practice.has_info))) !== null && _b !== void 0 ? _b : true);
        }
    },
    actions: {
        setActivePracticeGuide: (0, xstate_1.assign)({
            activePracticeGuide: (_, event) => {
                (0, assertEventType_1.assertEventType)(event, typings_1.GuidesEventType.FETCH_GUIDE);
                return event.payload.id;
            }
        }),
        setPracticeGuides: (0, xstate_1.assign)({
            practiceGuides: (context, event) => {
                if (context.activePracticeGuide == null)
                    return context.practiceGuides;
                (0, assertEventType_1.assertEventType)(event, typings_1.GuidesEventType.DONE_INVOKE_FETCH_GUIDE);
                return Object.assign(Object.assign({}, context.practiceGuides), { [context.activePracticeGuide]: event.data });
            }
        }),
        onFetchSuccess: NOOP,
        onFetchError: NOOP
    },
    services: {
        fetchGuide: (context) => __awaiter(void 0, void 0, void 0, function* () {
            if (context.activePracticeGuide == null)
                return null;
            const results = yield axios_1.default.get(urls_1.URLS.practice_guide(context.customerCode, context.activePracticeGuide), {
                headers: (0, headers_1.buildHeaders)(context.customerCode, context.productName)
            });
            return results.data;
        })
    }
});
exports.createGuidesMachine = createGuidesMachine;
//# sourceMappingURL=createGuidesMachine.js.map